/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ground': {
    width: 16,
    height: 16,
    viewBox: '0 0 459.101 459.101',
    data: '<path pid="0" d="M244.551 238.037V27.05h-30v210.987H0v30h459.101v-30zM49.551 320.043h360v30h-360zM94.551 402.05h270v30h-270z"/>'
  }
})
